import { Controller } from "@hotwired/stimulus"
import { showAlertModal } from "../lib/custom_confirm"

// Click-through explainer for subscription-locked controls (e.g. the Email
// Services tabs without a CRM subscription). Locked affordances stay visible
// and clickable — clicking explains the unlock in a styled modal instead of
// navigating or silently doing nothing.
//
// Usage:
//   %button{ data: { controller: 'locked-feature',
//                    action: 'locked-feature#explain',
//                    'locked-feature-message-value': '…',
//                    'locked-feature-title-value': '…' } }
export default class extends Controller {
  static values = {
    message: String,
    title: { type: String, default: "Locked feature" },
  }

  explain(event) {
    event.preventDefault()
    showAlertModal(this.messageValue, { title: this.titleValue })
  }
}
